export default "__VITE_ASSET__Cc_633KP__"